import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  ViewChildren,
  ChangeDetectorRef,
} from '@angular/core';
import { SelectItem, LazyLoadEvent, Table } from 'primeng';
import { ImportDataType } from '../../interfaces/data-import/import-data-type';
import { IDriver } from '../../interfaces/driver';
import { IDriverFilter } from '../../interfaces/driver-filter';
import { IPageResult } from '../../interfaces/page-result';
import { BoardingCheckListService } from '../../services';
import { IDriverService } from '../../services';
import { OrganisationsService } from '../../services';
import { ConfirmationService } from 'primeng';

@Component({
  selector: 'manage-driver',
  styleUrls: ['./manage-driver.component.scss'],
  templateUrl: './manage-driver.component.html',
})
export class ManageDriverComponent implements OnInit {
  public backTo: string;
  public isActiveCheckList: boolean = false;

  public page: IPageResult<IDriver> = {
    items: [],
    total: 0,
  };
  public selectedItem: any;

  @ViewChild('dt', { read: ElementRef }) dataTable: ElementRef;

  public event: any;
  public filter: Subject<IDriverFilter>;
  public filterVal: IDriverFilter;
  public isLoaded: boolean = false;
  public filterString: string;

  public uLevel: any;
  public orgType: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private driverService: IDriverService,
    private organisationsService: OrganisationsService,
    private changeDetector: ChangeDetectorRef,
    private boardingCheckListService: BoardingCheckListService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.boardingCheckListService
      .GetBoardingCheckList()
      .then((x) => {
        if (x) {
          this.isActiveCheckList = !x.isHide;
        }
      })
      .catch();

    this.initDefaultFilter();
    this.organisationsService.getCurrentUserOrgSubTypeId().then((resp) => {
      this.orgType = resp;
    });

    this.organisationsService.getUserOrganisationLevel().then((resp) => {
      this.uLevel = resp;
    });

    this.filter = new Subject<IDriverFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);
  }

  load(filter: IDriverFilter) {
    this.driverService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  onRowSelect(event) {
    this.event = event;
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      sortField: 'Name',
      sortOrder: 1,
      filters: {
        firstName: {},
        surname: {},
        nickName: {},
        mobileNumber: {},
        drivingLicenceNumber: {},
      },
    };
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0;
    this.filter.next(this.filterVal);
  }

  AddDriver() {
    this.router.navigate(['app/drivers/0']);
  }

  onEdit() {
    if (this.event !== undefined) {
      this.goToDetails(this.event.data.id);
    }
  }

  onRowDblclick(driver) {
    this.goToDetails(driver.id);
  }

  goToDetails(id: number) {
    this.router.navigate(['app/drivers/' + id]);
  }

  goToImportData() {
    this.router.navigate(['app/dataimport/' + ImportDataType.Drivers]);
  }

  close() {
    if (this.backTo) {
      this.router.navigate([this.backTo]);
    } else if (this.isActiveCheckList) {
      this.router.navigate(['app/']);
    }
  }

  lockUnlockUser(selectedItem: IDriver) {
    var action = selectedItem.isLockedOut ? 'enabled' : 'disabled';
    this.confirmationService.confirm({
      message: `Change user status to be ${action}?`,
      accept: () => {
        this.driverService.lockUplockDriver(selectedItem).then((res) => {
          this.load(this.filterVal);
          this.selectedItem = null;
        });
      },
    });
  }
}
